import { Layout } from "react-grid-layout";

import { GRID_WIDTH } from "./consts";

const findInsertPosition = (
  boardLayout: Pick<Layout, "h" | "w" | "x" | "y">[],
  newCard: { h: number; w: number }
): { x: number; y: number } => {
  // this is a two-dimensional grid, but represented as a flat array
  const grid: boolean[] = [];

  boardLayout.forEach((layout) => {
    for (let x = 0; x < layout.w; x++) {
      for (let y = 0; y < layout.h; y++) {
        grid[GRID_WIDTH * (layout.y + y) + layout.x + x] = true;
      }
    }
  });

  // now let's scan the grid row by row
  let y = 0;
  while (y < grid.length) {
    // and in each row, let's look for a sequence of
    // empty cells big enough to fit the new card
    let x = 0;
    let emptySpaceWidth = 0;
    while (x < GRID_WIDTH) {
      if (!grid[y + x]) {
        emptySpaceWidth++;

        // found empty space on a row equal to card width
        if (emptySpaceWidth === newCard.w) {
          // let's try to fit card here
          // for that, we need to ensure that rows below this space
          // are also empty (if card has height > 1)
          let fits = true;
          // calculate empty cells sequence start position
          const startX = x - emptySpaceWidth + 1;
          for (
            let cy = 1; // start from 1 because one row is already checked
            cy < newCard.h && fits;
            cy++
          ) {
            for (let cx = 0; cx < newCard.w && fits; cx++) {
              fits &&= !grid[y + GRID_WIDTH * cy + startX + cx];
            }
          }
          if (fits) {
            return { x: startX, y: y / GRID_WIDTH };
          }

          // let's proceed from this position (will be incremented right after)
          x = startX;
          emptySpaceWidth = 0;
        }
      } else {
        emptySpaceWidth = 0;
      }
      x++;
    }

    y += GRID_WIDTH;
  }

  return { x: 0, y: y / GRID_WIDTH };
};

export default findInsertPosition;
